import Image from "./Images/card1.jpeg";

const DataSet = [
  {
    id: "1002",
    author: "NASA",
    src: Image,
  },
  {
    id: "1003",
    author: "E+N Photographies",
    src: Image,
  },
  {
    id: "1004",
    author: "Greg Rakozy",
    src: Image,
  },
  {
    id: "1005",
    author: "Matthew Wiebe",
    src: Image,
  },
  {
    id: "1006",
    author: "Vladimir Kudinov",
    src: Image,
  },
  {
    id: "1008",
    author: "Benjamin Combs",
    src: Image,
  },
];

export default DataSet;
